export default "__VITE_ASSET__ChdeS8_K__"